import _toConsumableArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _createForOfIteratorHelper from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.error.to-string.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.string.pad-start.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { __decorate } from "tslib";
import Vue from "vue";
import Component from "vue-class-component";
import { Watch } from "vue-property-decorator";

var CarrelloDialog = /*#__PURE__*/function (_Vue) {
  _inherits(CarrelloDialog, _Vue);

  var _super = _createSuper(CarrelloDialog);

  function CarrelloDialog() {
    var _this;

    _classCallCheck(this, CarrelloDialog);

    _this = _super.apply(this, arguments);
    _this.noteCarrello = "";
    _this.cerca = "";
    _this.page = 1;
    _this.pageSize = 5;
    _this.pageSizes = [5, 10, 20, 50, 100];
    _this.dettaglioPers = [];
    _this.persDialog = false;
    _this.eliminaRiga = false;
    _this.eliminaCarrello = false;
    _this.rigaDaEliminare = "";
    _this.detailsLensDialog = false;
    _this.dettaglioOrdineLente = [];
    _this.ordineOk = false;
    _this.showConfirmOrder = false;
    return _this;
  }

  _createClass(CarrelloDialog, [{
    key: "carrelloDialog",
    get: function get() {
      return this.$store.state.carrelloDialog;
    }
  }, {
    key: "cartRows",
    get: function get() {
      return this.$store.state.configurator.cart.cartRows;
    }
  }, {
    key: "lenteVistaDx",
    get: function get() {
      return this.$store.state.configurator.lenteVistaDx;
    }
  }, {
    key: "lenteVistaSx",
    get: function get() {
      return this.$store.state.configurator.lenteVistaSx;
    }
  }, {
    key: "activeConfiguration",
    get: function get() {
      return this.$store.getters["configurator/getActiveConfiguration"];
    }
  }, {
    key: "lentiSole",
    get: function get() {
      return this.$store.getters["configurator/lenti/sunLenses"];
    }
  }, {
    key: "lentiClip",
    get: function get() {
      return this.$store.getters["configurator/lenti/clipLenses"];
    }
  }, {
    key: "closeCarrelloDialog",
    value: function closeCarrelloDialog(c) {
      if (this.ordineOk) {
        this.ordineOk = false;
      }

      this.$store.commit("openCloseCarrelloDialog", c);
    }
  }, {
    key: "openStoricoOrdiniDialog",
    value: function openStoricoOrdiniDialog(c) {
      if (this.ordineOk) {
        this.ordineOk = false;
      }

      this.closeCarrelloDialog(false);
      this.$store.commit("openCloseStoricoOrdiniDialog", c);
      this.$store.dispatch("configurator/user/getUserHistory");
    }
  }, {
    key: "pagedCartRows",
    get: function get() {
      return this.filteredFront.slice(this.pageSize * this.page - this.pageSize, this.pageSize * this.page);
    }
  }, {
    key: "heightTableBody",
    get: function get() {
      return this.pageSize * 60 + 71 + 1; // 60 è l'altezza delle righe della tabella impostata nel row-style, 71 è l'altezza dell'header
    }
  }, {
    key: "filteredFront",
    get: function get() {
      var _this2 = this;

      if (this.cerca && this.cerca != "") {
        return this.cartRows.filter(function (c) {
          return c.codice_modello.indexOf(_this2.cerca) >= 0;
        });
      } else {
        return this.cartRows;
      }
    }
  }, {
    key: "warnings",
    get: function get() {
      var warnings = {};

      var _iterator = _createForOfIteratorHelper(this.cartRows),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var row = _step.value;
          var warehouseInfo = this.findColorWarehouseInfo(row.colore_frontale);

          if (warehouseInfo && warehouseInfo.GiacIta < 1) {
            warnings[row.colore_frontale] = this.$t('message.Il_colore_{color}_è_esaurito,_data_di_arrivo:_{date}', {
              color: row.colore_frontale,
              date: this.formatDate(new Date(warehouseInfo.ShipDateIta))
            }).toString();
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return warnings;
    }
  }, {
    key: "findColorWarehouseInfo",
    value: function findColorWarehouseInfo(color) {
      return this.$store.state.configurator.frontali.colors.find(function (c) {
        return c.U_THE_COLORE == color;
      });
    }
  }, {
    key: "formatDate",
    value: function formatDate(date) {
      var day = String(date.getDate()).padStart(2, '0');
      var month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero based

      var year = date.getFullYear();
      return "".concat(day, "/").concat(month, "/").concat(year);
    }
  }, {
    key: "setSizePage",
    value: function setSizePage(val) {
      this.pageSize = val;
    }
  }, {
    key: "setPage",
    value: function setPage(val) {
      this.page = val;
    }
  }, {
    key: "personaliz",
    value: function personaliz(id) {
      var _this3 = this;

      if (this.dettaglioPers.length == 0) {
        // TODO: inserire tipo CartRow al posto di any quando inseriremo il campo id su CartRow su cfg-base-app
        this.pagedCartRows.forEach(function (e) {
          if (e.id == id) {
            _this3.dettaglioPers.push({
              label: _this3.$t("message.frontale").toUpperCase(),
              nome: e.nome,
              coloreTesto: e.colore_nome,
              fontTesto: e.font_nome
            }, {
              label: _this3.$t("message.frontale").toUpperCase(),
              nome: e.nomeCilDx,
              coloreTesto: e.coloreNomeCilDx,
              fontTesto: e.fontNomeCilDx
            }, {
              label: _this3.$t("message.esterno").toUpperCase() + " " + _this3.$t("message.Asta_sinistra").toUpperCase(),
              nome: e.nomeExtAstaSx,
              coloreTesto: e.coloreNomeExtAstaSx,
              fontTesto: e.fontNomeExtAstaSx
            }, {
              label: _this3.$t("message.interno").toUpperCase() + " " + _this3.$t("message.Asta_sinistra").toUpperCase(),
              nome: e.nomeIntAstaSx,
              coloreTesto: e.coloreNomeIntAstaSx,
              fontTesto: e.fontNomeIntAstaSx
            }, {
              label: _this3.$t("message.esterno").toUpperCase() + " " + _this3.$t("message.Asta_destra").toUpperCase(),
              nome: e.nomeExtAstaDx,
              coloreTesto: e.coloreNomeExtAstaDx,
              fontTesto: e.fontNomeExtAstaDx
            }, {
              label: _this3.$t("message.interno").toUpperCase() + " " + _this3.$t("message.Asta_destra").toUpperCase(),
              nome: e.nomeIntAstaDx,
              coloreTesto: e.coloreNomeIntAstaDx,
              fontTesto: e.fontNomeIntAstaDx
            });
          }
        });
      }

      this.persDialog = true;
    }
  }, {
    key: "getUserCart",
    value: function getUserCart() {
      this.$store.dispatch("configurator/user/getUserCart");
    }
  }, {
    key: "svuotaCarrello",
    value: function () {
      var _svuotaCarrello = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.eliminaCarrello = false;
                _context.next = 3;
                return this.$store.dispatch("configurator/cart/emptyCart");

              case 3:
                this.getUserCart();

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function svuotaCarrello() {
        return _svuotaCarrello.apply(this, arguments);
      }

      return svuotaCarrello;
    }()
  }, {
    key: "deleteCartRow",
    value: function () {
      var _deleteCartRow = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(id) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.$store.dispatch("configurator/cart/deleteCartRow", id);

              case 2:
                this.getUserCart();

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function deleteCartRow(_x) {
        return _deleteCartRow.apply(this, arguments);
      }

      return deleteCartRow;
    }()
  }, {
    key: "checkCancRiga",
    value: function checkCancRiga(id) {
      this.eliminaRiga = true;
      this.rigaDaEliminare = id;
    }
  }, {
    key: "cancRiga",
    value: function () {
      var _cancRiga = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(id) {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.eliminaRiga = false;
                _context3.next = 3;
                return this.deleteCartRow(id);

              case 3:
                this.getUserCart();

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function cancRiga(_x2) {
        return _cancRiga.apply(this, arguments);
      }

      return cancRiga;
    }()
  }, {
    key: "getRowClass",
    value: function getRowClass(data) {
      return data.row.nome === "" ? "hidden" : "";
    }
  }, {
    key: "sendOrder",
    value: function sendOrder() {
      this.ordineOk = true;
      this.$store.dispatch("configurator/cart/checkout", this.noteCarrello);
      this.getUserCart();
      this.noteCarrello = "";
    } // mounted() {
    //   console.log(
    //     this.$store.commit,
    //     "STATEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEEE"
    //   );
    // }

  }, {
    key: "setDettaglioOrdineLente",
    value: function setDettaglioOrdineLente(row) {
      var _this4 = this;

      if (row.lensright && row.lensleft) {
        if (this.dettaglioOrdineLente.length == 0) {
          // TODO: inserire tipo CartRow al posto di any quando inseriremo il campo id su CartRow su cfg-base-app
          this.pagedCartRows.forEach(function (e) {
            if (e.id == row.id) {
              _this4.dettaglioOrdineLente.push({
                label: _this4.$t("message.Lente_destra").toUpperCase(),
                lens: e.lensright,
                lensModel: e.lensrightdescr,
                reference: _this4.activeConfiguration.note,
                notes: e.note,
                lensestype: "MONOFOCALE",
                sfera: e.sphright,
                cilindro: e.cylright,
                asse: e.axisright,
                semiDist: e.pdright,
                altPup: e.heightright,
                add: e.addright
              }, {
                label: _this4.$t("message.Lente_sinistra").toUpperCase(),
                lens: e.lensleft,
                lensModel: e.lensleftdescr,
                reference: _this4.activeConfiguration.note,
                notes: e.note,
                lensestype: "MONOFOCALE",
                sfera: e.sphleft,
                cilindro: e.cylleft,
                asse: e.axisleft,
                semiDist: e.pdleft,
                altPup: e.heightleft,
                add: e.addleft
              });
            }
          });
        }

        this.detailsLensDialog = true;
      } else if (row.lenssun) {
        var lente = [].concat(_toConsumableArray(this.lentiSole), _toConsumableArray(this.lentiClip)).find(function (l) {
          return l.ItemCode == row.lenssun;
        });

        if (this.dettaglioOrdineLente.length == 0) {
          this.pagedCartRows.forEach(function (e) {
            if (e.id == row.id) {
              _this4.dettaglioOrdineLente.push({
                label: _this4.$t("message.Lente_sole").toUpperCase(),
                lens: e.lenssun,
                lensModel: lente ? lente.ItemName : e.lenssun,
                reference: e.note,
                notes: "",
                lensestype: "",
                sfera: 0,
                cilindro: 0,
                asse: 0,
                semiDist: 0,
                altPup: 0,
                add: 0
              });
            }
          });
        }

        this.detailsLensDialog = true;
      }
    }
  }, {
    key: "persDialogChanged",
    value: function persDialogChanged(newV) {
      if (newV == false) {
        this.dettaglioPers = [];
      }
    }
  }, {
    key: "detailsLensDialogChanged",
    value: function detailsLensDialogChanged(newV) {
      if (newV == false) {
        this.dettaglioOrdineLente = [];
      }
    }
  }]);

  return CarrelloDialog;
}(Vue);

__decorate([Watch("persDialog")], CarrelloDialog.prototype, "persDialogChanged", null);

__decorate([Watch("detailsLensDialog")], CarrelloDialog.prototype, "detailsLensDialogChanged", null);

CarrelloDialog = __decorate([Component({})], CarrelloDialog);
export default CarrelloDialog;